import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { Row, Col } from "reactstrap";

const PaginatedItems = ({
  itemsPerPage,
  totalCount,
  selectedPage,
  onPageChange,
  itemsPerPages,
}) => {
  // eslint-disable-next-line
  // const [currentItems, setCurrentItems] = useState(null);
  // const [pageCount, setPageCount] = useState(0);
  // const [itemOffset, setItemOffset] = useState(0);
  const [pageCount, setPageCount] = useState(0);

  useEffect(() => {
    // Fetch items from another resources.

    setPageCount(Math.ceil(totalCount / itemsPerPage));
  }, [itemsPerPage, totalCount]);

  // Invoke when user click to request another page.
  const _handlePageClick = (event) => {
    onPageChange(event.selected);
  };

  return (
    <>
      <Row className="mt-3 align-items-center">
        <Col md={6}>
          <div className="tableCount">
            Showing {itemsPerPages} entries out of {totalCount} entries
          </div>
        </Col>
        <Col md={6}>
          <ReactPaginate
            breakLabel="..."
            nextLabel=">"
            onPageChange={_handlePageClick}
            pageRangeDisplayed={3}
            pageCount={pageCount}
            previousLabel="<"
            renderOnZeroPageCount={null}
            className="pagination justify-content-end"
          />
        </Col>
      </Row>
    </>
  );
};

export default PaginatedItems;
